import type { OpenOptions } from '../types';

/**
 * 把 OpenOptions 序列化成访客页 daji_* query string。
 * host 由调用方注入（H5 端传 location.host，小程序端传 ''）。
 * 零 DOM 依赖。
 *
 * 安全注意：token 以明文出现在 URL query（daji_token=xxx），
 * 会被浏览器历史 / Referrer / 服务端 access-log 记录。
 * 生产环境应迁移到 postMessage 下发 token。
 */
export function buildQuery(opts: OpenOptions, sdkVersion: string, host: string): string {
  const params: Record<string, string> = {
    daji_userId: String(opts.userId ?? ''),
    daji_userName: String(opts.userName ?? ''),
    daji_userType: String(opts.userType ?? ''),
    daji_language: String(opts.language ?? ''),
    daji_priceType: String(opts.priceType ?? ''),
    daji_supplierId: String(opts.supplierId ?? ''),
    daji_host: host,
    sdk: sdkVersion,
  };
  return Object.entries(params)
    .filter(([, v]) => v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
}

export function buildQueryWithToken(opts: OpenOptions, sdkVersion: string, host: string): string {
  const base = buildQuery(opts, sdkVersion, host);
  const token = String(opts.token ?? '');
  if (!token) return base;
  const tokenQs = `${encodeURIComponent('daji_token')}=${encodeURIComponent(token)}`;
  return [base, tokenQs].filter(Boolean).join('&');
}
